export const headerTooltipText = {
  payment:
    'Select your default payment method. If your preferred payment method isn’t shown below, then select Add new.',
};
